<template>
  <v-layout
    class="patient-page"
    column
  >

    <v-container
      fluid
      grid-list-md
    >
      <span class="headerTabSelected">Admin</span>
      <v-layout
        row
        wrap
        mb-3
      >
        <v-btn
          router
          :to="{name: 'AdminUploadsPage'}"
          depressed
        >Documents</v-btn>
        <v-btn
          router
          :to="{name: 'AdminFileUploadPage'}"
          depressed
        >Add Medical Record</v-btn>
        <v-btn
          router
          :to="{name: 'AdminRequestsPage'}"
          depressed
        >Requests</v-btn>
        <v-btn
          router
          :to="{name: 'AdminPatientsPage'}"
          depressed
        >Patients</v-btn>
        <v-btn
          router
          :to="{name: 'AdminProvidersPage'}"
          depressed
        >Providers</v-btn>
      </v-layout>
      <span class="headerTabSelected">Stats</span>
      <v-data-iterator
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        content-tag="v-layout"
        row
        wrap
      >
        <v-flex
          slot="item"
          slot-scope="props"
          xs12
          sm6
          md4
          lg3
        >
          <v-card flat>
            <v-card-title>
              <h4>{{ props.item.name }}</h4>
            </v-card-title>
            <v-divider></v-divider>
            <div
              v-show="!patientSearchResults"
              class="text-xs-center mt-4"
            >
              <v-progress-circular
                :size="30"
                :width="3"
                color="#eeeeee"
                indeterminate
              ></v-progress-circular>
            </div>
            <v-list
              v-show="patientSearchResults"
              dense
            >
              <v-list-tile>
                <v-list-tile-content>Total Patients:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.totalPatients }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>New Patients Today:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.newPatientsToday }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>New Patients This Month:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.newPatientsThisMonth }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>New Patients Last Month:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item.newPatientsLastMonth }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-data-iterator>

    </v-container>

  </v-layout>
</template>

<style lang="scss" scoped>
.table-border {
  border: 1px solid #e6e6e8;
}
.adminCard {
  background-color: #eeeeee;
  cursor: pointer;
  border-radius: 6px;
  height: 180px;
}

.adminCard:hover {
  background-color: white;
  border: 1px solid #e8eaed;
}

.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.blue-back {
  background: white;
}

.account-title {
  font-size: 24px;
  line-height: 30px;
  color: white;
}
</style>

<script>
import { mapActions, mapState } from 'vuex'
import HelperMixin from '@/core/mixins/HelperMixin'

export default {
  mixins: [HelperMixin],
  components: {},
  data() {
    return {
      rowsPerPageItems: [4],
      pagination: {
        rowsPerPage: 4
      },
      items: [
        {
          value: false,
          name: 'OneChart Overview',
          totalPatients: 0,
          newUsersToday: 0,
          newPatientsToday: 0,
          newPatientsThisMonth: 0,
          newPatientsLastMonth: 0
        },
        {
          value: false,
          name: 'Smart Choice',
          totalPatients: 0,
          newUsersToday: 0,
          newPatientsToday: 0,
          newPatientsThisMonth: 0,
          newPatientsLastMonth: 0
        },
        {
          value: false,
          name: 'Imagine MD',
          totalPatients: 0,
          newUsersToday: 0,
          newPatientsToday: 0,
          newPatientsThisMonth: 0,
          newPatientsLastMonth: 0
        },
        {
          value: false,
          name: 'Grayhawk',
          totalPatients: 0,
          newUsersToday: 0,
          newPatientsToday: 0,
          newPatientsThisMonth: 0,
          newPatientsLastMonth: 0
        }
      ]
    }
  },
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getSmartChoicePatientList'
    ]),
    exportDataSet(dataSet) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += dataSet.join(',\n')
      let encodedUri = encodeURI(csvContent)
      window.open(encodedUri)
    },
    createUserPatientMatch() {
      if (
        this.userSearchResults &&
        this.userIDsOfCreatorsOfPatients.length > 0
      ) {
        this.userSearchResults.forEach(user => {
          if (!this.userIDsOfCreatorsOfPatients.includes(user.id)) {
            if (!this.patientCreatorUsers.includes(user)) {
              this.patientCreatorUsers.push(user)
            }
          } else {
            if (!this.nonPatientCreatorUsers.includes(user)) {
              this.nonPatientCreatorUsers.push(user)
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapState('admin', ['patientSearchResults', 'userSearchResults'])
  },
  watch: {
    userSearchResults() {
      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch()
      }
      this.oneChartUsers = this.userSearchResults.length
      this.items[0].totalUsers = this.userSearchResults.length

      let todayCuttoffDate = new Date()
      todayCuttoffDate.setHours(0, 0, 0, 0)
      let todayCuttoff = todayCuttoffDate.getTime() / 1000

      let newUsersToday = 0
      this.userSearchResults.forEach(user => {
        // is this user from today?
        if (user.created > todayCuttoff) {
          newUsersToday = newUsersToday + 1
        }
        this.items[0].newUsersToday = newUsersToday
      })
    },
    patientSearchResults() {
      this.items[0].name = 'OneChart Patient Population'
      this.items[0].totalPatients = this.patientSearchResults.length

      // divide the patients by day this week and this month.

      let todayCuttoffDate = new Date()
      todayCuttoffDate.setHours(0, 0, 0, 0)
      let todayCuttoff = todayCuttoffDate.getTime() / 1000

      let thisMonthCutOff = this.getTimestampOfStartOfThisMonth()

      let previousMonthCutOff = this.getTimestampOfStartOfPreviousMonth()
      console.log('this month cutoff')
      console.log(thisMonthCutOff)

      let newPatientsToday = 0
      let newPatientsThisMonth = 0
      let newPatientsLastMonth = 0

      let smartChoiceNewPatientsToday = 0
      let smartChoiceOverallNewPatients = 0
      let smartChoiceNewPatientsThisMonth = 0
      let smartChoiceNewPatientsLastMonth = 0

      let imagineMDNewPatientsToday = 0
      let imagineMDOverallNewPatients = 0
      let imagineMDNewPatientsThisMonth = 0
      let imagineMDNewPatientsLastMonth = 0

      let grayhawkNewPatientsToday = 0
      let grayhawkOverallNewPatients = 0
      let grayhawkNewPatientsThisMonth = 0
      let grayhawkNewPatientsLastMonth = 0

      this.patientSearchResults.forEach(patient => {
        // is this patient from today?
        // who does this patient belong to?
        if (patient.partner) {
          if (patient.partner.id) {
            if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
              // this is a smart choice affiliated patient
              smartChoiceOverallNewPatients = smartChoiceOverallNewPatients + 1
            }
            if (patient.partner.id === '5acb94000495d7065c909bc2') {
              // this is a grayhawk affiliated patient
              grayhawkOverallNewPatients = grayhawkOverallNewPatients + 1
            }
            if (patient.partner.id === '5b73507c4aef2028740f662b') {
              // this is a imaginemd affiliated patient
              imagineMDOverallNewPatients = imagineMDOverallNewPatients + 1
            }
          }
        }
        if (patient.created > todayCuttoff) {
          newPatientsToday = newPatientsToday + 1
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsToday = smartChoiceNewPatientsToday + 1
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsToday = grayhawkNewPatientsToday + 1
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsToday = imagineMDNewPatientsToday + 1
              }
            }
          }
        }

        if (patient.created > thisMonthCutOff) {
          newPatientsThisMonth = newPatientsThisMonth + 1
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsThisMonth =
                  smartChoiceNewPatientsThisMonth + 1
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsThisMonth = grayhawkNewPatientsThisMonth + 1
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsThisMonth =
                  imagineMDNewPatientsThisMonth + 1
              }
            }
          }
        } else if (patient.created > previousMonthCutOff) {
          newPatientsLastMonth = newPatientsLastMonth + 1
          if (patient.partner) {
            if (patient.partner.id) {
              if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
                // this is a smart choice affiliated patient
                smartChoiceNewPatientsLastMonth =
                  smartChoiceNewPatientsLastMonth + 1
              }
              if (patient.partner.id === '5acb94000495d7065c909bc2') {
                // this is a grayhawk affiliated patient
                grayhawkNewPatientsLastMonth = grayhawkNewPatientsLastMonth + 1
              }
              if (patient.partner.id === '5b73507c4aef2028740f662b') {
                // this is a imaginemd affiliated patient
                imagineMDNewPatientsLastMonth =
                  imagineMDNewPatientsLastMonth + 1
              }
            }
          }
        }

        this.items[0].newPatientsToday = newPatientsToday
        this.items[0].newPatientsThisMonth = newPatientsThisMonth
        this.items[0].newPatientsLastMonth = newPatientsLastMonth

        this.items[1].totalPatients = smartChoiceOverallNewPatients
        this.items[1].newPatientsToday = smartChoiceNewPatientsToday
        this.items[1].newPatientsThisMonth = smartChoiceNewPatientsThisMonth
        this.items[1].newPatientsLastMonth = smartChoiceNewPatientsLastMonth

        this.items[2].totalPatients = imagineMDOverallNewPatients
        this.items[2].newPatientsToday = imagineMDNewPatientsToday
        this.items[2].newPatientsThisMonth = imagineMDNewPatientsThisMonth
        this.items[2].newPatientsLastMonth = imagineMDNewPatientsLastMonth

        this.items[3].totalPatients = grayhawkOverallNewPatients
        this.items[3].newPatientsToday = grayhawkNewPatientsToday
        this.items[3].newPatientsThisMonth = grayhawkNewPatientsThisMonth
        this.items[3].newPatientsLastMonth = grayhawkNewPatientsLastMonth
      })
    }
  },
  created() {
    this.$router.push({
      name: 'AdminDocumentsPage'
    })

    this.getPatientList()
    this.getUserList()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/AdminLandingPage.vue